import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as config from "../../constants/config";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as formulaActions from "../../actions/formulaActions";
import * as getterHelper from "../../helpers/getterHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.GET_CUSTOMERS_BY_PARAMS:
            if (!responseHelper.isGetCustomersByParamsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_CUSTOMER_LIST,
                    payload: {
                        tabId: tabId,
                        customerList: response.data.customerList
                    }
                }
            ];
        case handlers.GET_CUSTOMERS_WITH_OFFSET:
            if (!responseHelper.isGetCustomersByParamsFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_CUSTOMER_LIST_WITH_OFFSET,
                    payload: {
                        tabId: tabId,
                        customerList: response.data.customerList
                    }
                }
            ];
        case handlers.GET_ALL_CUSTOMERS:
            if (!responseHelper.isGetAllCustomersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_CUSTOMER_LIST,
                    payload: {
                        tabId: tabId,
                        customerList: response.data.customerList
                    }
                }
            ];
        case handlers.GET_LAST_CUSTOMERS:
            if (!responseHelper.isGetLastCustomersFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_LAST_CUSTOMER_LIST,
                    payload: {
                        tabId: tabId,
                        lastCustomerList: response.data
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            search: "",
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.GET_CUSTOMERS_BY_PARAMS,
                    tabId: tabId
                }
            ];
        case handlers.GET_CUSTOMER_DETAIL:
            if (!responseHelper.isGetCustomerFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let customerActions = [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.CUSTOMERS_MODAL
                    }
                },
                {
                    type: actionTypes.CUSTOMERS_CHANGE_OFFSET,
                    payload: {
                        tabId: tabId,
                        offset: config.MAX_CUSTOMER_LIMIT
                    }
                },
                {
                    type: actionTypes.CUSTOMERS_CHANGE_FILTER,
                    payload: {
                        tabId: tabId,
                        filter: ""
                    }
                },
                {
                    type: actionTypes.SAVE_CUSTOMER_DETAIL,
                    payload: {
                        tabId: tabId,
                        customer: response.data
                    }
                }
            ];

            if (state.formula[tabId] === undefined) {
                return customerActions;
            }

            if (response.data.margin === null) {
                customerActions.push({
                    type: actionTypes.RELOAD_FORMULA_META_DATA,
                    payload: {
                        tabId: tabId
                    }
                });
            } else {
                customerActions.push(
                    formulaActions.setMargin(
                        tabId,
                        getterHelper.getObjectById(state.global.customMarginList, response.data.margin.id)
                    )
                );
            }

            return customerActions;
        case handlers.CUSTOMERS_TAB_GET_DETAIL:
            if (!responseHelper.isGetCustomerFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_CUSTOMER_DETAIL,
                    payload: {
                        tabId: tabId,
                        customer: response.data
                    }
                },
                {
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.DETAIL_SCENE
                    }
                }
            ];
        case handlers.ADD_CUSTOMER:
            if (!responseHelper.isAddCustomerFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            let addCustomerRequests = [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_CUSTOMER_MODAL
                    }
                },
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.CUSTOMERS_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMER_DETAIL,
                        params: {
                            id: response.data.customerId
                        }
                    },
                    method: handlers.GET_CUSTOMER_DETAIL,
                    tabId: tabId
                }
            ];

            let tabList = state.navigation.tabList.filter(
                (tab) => tab.type === componentTypes.MAIN_TAB || tab.type === componentTypes.CUSTOMERS_TAB
            );

            let tab;
            for (tab of tabList) {
                addCustomerRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            search: state.customers[tab.id] ? state.customers[tab.id].filter : "",
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.GET_CUSTOMERS_BY_PARAMS,
                    tabId: tab.id
                });
            }

            return addCustomerRequests;
        case handlers.LIGHT_ADD_CUSTOMER:
            if (!responseHelper.isAddCustomerFormatValid(response)) {
                return [messageHelper.getInvalidFormatMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMER_DETAIL,
                        params: {
                            id: response.data.customerId
                        }
                    },
                    method: handlers.GET_CUSTOMER_DETAIL,
                    tabId: tabId
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            search: "",
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.GET_CUSTOMERS_WITH_OFFSET,
                    tabId: tabId
                },
                {
                    type: actionTypes.SET_ACTIVE_TAB_SCENE,
                    payload: {
                        tabId: tabId,
                        scene: componentTypes.SUMMARY_SCENE
                    }
                }
            ];
        case handlers.EDIT_CUSTOMER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let editCustomerRequests = [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.EDIT_CUSTOMER_MODAL
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMER_DETAIL,
                        params: {
                            id: state.customers[tabId].customer ? state.customers[tabId].customer.id : null
                        }
                    },
                    method: handlers.GET_CUSTOMER_DETAIL,
                    tabId: tabId
                }
            ];

            let editCustomerTabList = state.navigation.tabList.filter(
                (tab) => tab.type === componentTypes.MAIN_TAB || tab.type === componentTypes.CUSTOMERS_TAB
            );

            let editCustomerTab;
            for (editCustomerTab of editCustomerTabList) {
                editCustomerRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            search: state.customers[editCustomerTab.id]
                                ? state.customers[editCustomerTab.id].filter
                                : "",
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.GET_CUSTOMERS_BY_PARAMS,
                    tabId: editCustomerTab.id
                });
            }

            return editCustomerRequests;
        case handlers.DELETE_CUSTOMER:
            if (response.result !== resultCodes.RESULT_OK) {
                return [messageHelper.getFlashMessage(response)];
            }

            let deleteCustomerRequests = [
                {
                    type: actionTypes.SAVE_CUSTOMER_DETAIL,
                    payload: {
                        tabId: tabId,
                        customer: null
                    }
                }
            ];

            let deleteCustomerTabList = state.navigation.tabList.filter(
                (tab) => tab.type === componentTypes.MAIN_TAB || tab.type === componentTypes.CUSTOMERS_TAB
            );

            let deleteCustomerTab;
            for (deleteCustomerTab of deleteCustomerTabList) {
                deleteCustomerRequests.push({
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CUSTOMERS_BY_PARAMS,
                        params: {
                            search: state.customers[deleteCustomerTab.id]
                                ? state.customers[deleteCustomerTab.id].filter
                                : "",
                            rowCount: config.MAX_CUSTOMER_LIMIT,
                            offset: 0
                        }
                    },
                    method: handlers.GET_CUSTOMERS_BY_PARAMS,
                    tabId: deleteCustomerTab.id
                });
            }

            return deleteCustomerRequests;
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
